import React from 'react';
import * as TYPES from 'constants/ActionTypes';
import { get } from 'lodash';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { addNotification } from 'reapop';
import { custom } from '../utils/Api';

const API2 = '/kjarni/api/v2';
const getData = entity => custom({ url: `${API2}/${entity}`, method: 'GET' });
const postData = (entity, data) => custom({ url: `${API2}/${entity}`, method: 'POST', data });

export const initApprovalRequest = () => ({
  type: TYPES.PERDIEM_INIT_APPROVAL_REQUEST,
});

export const initApprovalSuccess = data => ({
  type: TYPES.PERDIEM_INIT_APPROVAL_SUCCESS,
  data,
});

export const initApprovalFailure = error => ({
  type: TYPES.PERDIEM_INIT_APPROVAL_FAILURE,
  error,
});

export const initApproval = () => async (dispatch, getState) => {
  try {
    const {
      WebValuesReducer: {
        valuesByKey,
      },
    } = getState();
    const fixedAmountType = get(valuesByKey, ['PerDiem.IsFixed.Type', 'Value']);
    dispatch(initApprovalRequest());

    const [
      perDiemListRes,
      perDiemLocationListRes,
      perDiemTypeListRes,
    ] = await Promise.all([
      getData('PerDiems'),
      getData('PerDiemLocations'),
      getData('PerDiemTypes'),
    ]);

    const data = {
      perDiemList: get(perDiemListRes, 'data.value', []),
      perDiemLocationList: get(perDiemLocationListRes, 'data.value', []),
      perDiemTypeList: get(perDiemTypeListRes, 'data.value', []),
      perDiemAmountTypeFixed: fixedAmountType,
    };
    dispatch(initApprovalSuccess(data));
  } catch (error) {
    dispatch(initApprovalFailure(error));
  }
};

export const perDiemApproval = () => ({
  type: TYPES.PERDIEM_APPROVAL_REQUEST,
});

export const perDiemApprovalSuccess = () => ({
  type: TYPES.PERDIEM_APPROVAL_SUCCESS,
});

export const perDiemApprovalFailure = error => ({
  type: TYPES.PERDIEM_APPROVAL_FAILURE,
  error,
});

export const createPerDiemApprovalRequest = (data, callback) => async (dispatch, getState) => {
  dispatch(perDiemApproval());
  try {
    const {
      loginReducer: {
        user: { DefaultEmployeeDetailID },
      },
    } = getState();
    const editedData = {
      ...data,
      EmployeeDetailID: DefaultEmployeeDetailID,
      EmployeeDetailApprovalRequestType: 'PerDiemRecordsHandler',
      RequestTitle: 'Dagpeningabeiðni/Per diem request',
      ExpirationDate: moment('9999-12-31 00:00:00.000').toISOString(),
    };

    await postData('EmployeeDetailApprovalRequests', editedData);
    dispatch(perDiemApprovalSuccess());
    // Notificaiton on success
    dispatch(addNotification({
      title: <FormattedMessage id="approvalRequest.create.success" />,
      status: 'success',
      dismissible: true,
      dismissAfter: 5000,
    }));
    callback();
  } catch (error) {
    dispatch(perDiemApprovalFailure(error));
    // Notification on error
    dispatch(addNotification({
      title: <FormattedMessage id="approvalRequest.create.error" />,
      message: get(error, 'message'),
      status: 'error',
      dismissible: true,
      dismissAfter: 12000,
    }));
    callback();
  }
};

export const calculateRequest = () => ({
  type: TYPES.CALCULATE_REQUEST,
});

export const calculateSuccess = calculatedRecord => ({
  type: TYPES.CALCULATE_SUCCESS,
  calculatedRecord,
});

export const calculateFailure = error => ({
  type: TYPES.CALCULATE_FAILURE,
  error,
});

export const calculateReset = () => ({
  type: TYPES.CALCULATE_RESET,
});

export const calculate = data => async (dispatch) => {
  if (!data) {
    dispatch(calculateReset());
  }
  dispatch(calculateRequest());
  try {
    const res = await postData('PerDiemRecords/Calculate', data);
    const record = get(res, 'data');
    dispatch(calculateSuccess(record));
  } catch (error) {
    dispatch(calculateFailure(error));
  }
};

export const usePerDiemState = () => useSelector(state => state.perDiemReducer);



// WEBPACK FOOTER //
// ./src/actions/PerDiem.js